import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form } from '@unform/web';

import {
  FiMessageSquare,
  FiSearch,
  FiVideo,
  FiVideoOff,
  FiStar,
  FiArrowLeft,
} from 'react-icons/fi';

// Servicos
import api from 'services/api';

// Components
import Widget from 'components/Widget';
import Card from 'components/Card';
import Input from 'components/Input';
import Flag from 'components/Flag';
import Button from 'components/Button';

import { Container, Header, Tr, TableLinhaRoteiro } from './styles';
import { Scroll, Td } from 'styles/global';
import { show } from 'store/modules/dialog/actions';
import { useDispatch } from 'react-redux';
import { Avaliacaoeng, LinhaRoteiroStatusGravacao } from 'utils/variables';
import { Comercial } from 'pages/@types';

interface ILinhaRoteiro {
  id: number;
  codmaterial: number;
  titulo: string;
  cliente: string;
  statusgravacao: string;
  status: {
    info: string;
    type:
      | 'reprovado'
      | 'emandamento'
      | 'erro'
      | 'error'
      | 'entregue'
      | 'indisponivel'
      | 'fila_download'
      | 'pendente'
      | 'baixando'
      | 'fila_envio'
      | 'aprovado';

    nome: string;
  };
  abrangencia: string;
  programa: IPrograma;
  comercial: Comercial;
  separador: boolean;
  ippt: string;
  numippt: number;
}
interface IPrograma {
  nome: string;
}
interface ITotalGravados {
  exibrede: number;
  gravado: number;
  naogravado: number;
}

export default function LinhasRoteiro() {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * USE STATE
   */
  const [linhasRoteiroCompleto, setLinhasRoteiroCompleto] = useState<
    ILinhaRoteiro[]
  >([]);
  const [filtro, setFiltro] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [nomeRoteiro, setNomeRoteiro] = useState('Roteiro');
  const [totalGravados, setTotalGravados] = useState({} as ITotalGravados);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const linhasRoteiro = filtroStatus
    ? linhasRoteiroCompleto.filter(l => l.statusgravacao === filtroStatus)
    : linhasRoteiroCompleto.filter(
        l =>
          l.titulo.includes(filtro.toUpperCase()) ||
          l.codmaterial.toString().includes(filtro) ||
          l.cliente.includes(filtro.toUpperCase()) ||
          l.programa.nome.includes(filtro.toUpperCase()),
      );
  /**
   * USE PARAMS
   */
  const { roteiroId } = useParams<{ roteiroId: string }>();

  /**
   * USE EFFECT
   */
  useEffect(() => {
    async function loadRoteiro() {
      const response = await api.get(`/roteiros/${roteiroId}`);

      if (response.data.statusCode === 428) {
        console.log('ERRO!');
      } else {
        const data = response.data.linhasroteiro.map(
          (linha: ILinhaRoteiro) => linha,
        );
        // setLinhasRoteiro(data);
        setLinhasRoteiroCompleto(data);
        setNomeRoteiro(response.data.roteiro.filename);
        setTotalGravados(response.data.totalGravados);
      }
      setLoading(false);
    }

    if (roteiroId) {
      setLoading(true);
      loadRoteiro();
    }
  }, [roteiroId]);

  const handleReprovaEng = useCallback(
    linharoteiro => {
      const contentHTML = `<p>Observação: ${linharoteiro.comercial.midia.obseng}</p>`;
      const options = {
        type: 'info',
        contentHTML,
        confirmButtonText: 'FECHAR',
        showCancelButton: false,
        showConfirmButton: true,
      };
      dispatch(show(options));
    },
    [dispatch],
  );

  return (
    <Container>
      <Header>
        <Button size="lg" color="primary" onClick={() => navigate(-1)}>
          VOLTAR
          <FiArrowLeft />
        </Button>
        <Widget
          title="Gravados"
          showLink={false}
          // to="/dashboard/globoexpress"
          handleClick={() =>
            setFiltroStatus(prevState =>
              prevState === 'gravado' ? '' : 'gravado',
            )
          }
          active={filtroStatus === 'gravado'}
          icon={<FiVideo />}
          color="success"
          loading={loading}
          type="mini"
          data={totalGravados.gravado}
        />
        <Widget
          title="Não Gravados"
          showLink={false}
          // to="/dashboard/globoexpress"
          handleClick={() =>
            setFiltroStatus(prevState =>
              prevState === 'naogravado' ? '' : 'naogravado',
            )
          }
          active={filtroStatus === 'naogravado'}
          icon={<FiVideoOff />}
          color="danger"
          type="mini"
          loading={loading}
          data={totalGravados.naogravado}
        />
        <Widget
          title="Rede"
          showLink={false}
          // to="/dashboard/globoexpress"
          handleClick={() =>
            setFiltroStatus(prevState =>
              prevState === 'exibrede' ? '' : 'exibrede',
            )
          }
          active={filtroStatus === 'exibrede'}
          icon={<FiStar />}
          color="rede"
          loading={loading}
          type="mini"
          data={totalGravados.exibrede}
        />
      </Header>
      <Card>
        <>
          <header>
            <h4>{nomeRoteiro}</h4>
            <div>
              <Form onSubmit={() => {}}>
                <Input
                  name="searchLocal"
                  placeholder="Buscar na Tabela"
                  icon={<FiSearch />}
                  onChange={e => {
                    setFiltroStatus('');
                    setFiltro(e.target.value);
                  }}
                />
              </Form>
            </div>
          </header>
          {linhasRoteiro.length > 0 && !loading && (
            <Scroll>
              <TableLinhaRoteiro>
                <thead>
                  <tr>
                    <th>CM</th>
                    <th>TITULO</th>
                    <th>ABRANGÊNCIA</th>
                    <th>PROGRAMA</th>
                    <th>INTERVALO</th>
                    <th>STATUS</th>
                    <th>GRAVAÇÃO</th>
                  </tr>
                </thead>

                <tbody>
                  {!!linhasRoteiro &&
                    linhasRoteiro.map((l: ILinhaRoteiro) => (
                      <Tr key={l.id} separador={l.separador}>
                        <Td>{l.codmaterial}</Td>
                        <td>{l.titulo}</td>
                        <td>{l.abrangencia}</td>
                        <td>
                          {l.programa ? l.programa.nome : 'NÃO IDENTIFICADO'}
                        </td>
                        <td>{l.ippt + ' ' + l.numippt}</td>
                        <td>
                          {l.statusgravacao ===
                            LinhaRoteiroStatusGravacao.NAOGRAVADO && (
                            <Flag
                              name={l.status.nome}
                              type={l.status.type}
                              tooltip={l.status.info}
                              handleAction={() => handleReprovaEng(l)}
                              icon={
                                l.comercial?.midia?.avaliacaoeng ===
                                Avaliacaoeng.REPROVADO ? (
                                  <FiMessageSquare />
                                ) : null
                              }
                            />
                          )}
                        </td>
                        <td>
                          <Flag
                            name={
                              l.statusgravacao ===
                              LinhaRoteiroStatusGravacao.NAOGRAVADO
                                ? 'NÃO GRAVADO'
                                : l.statusgravacao ===
                                  LinhaRoteiroStatusGravacao.EXIBREDE
                                ? 'REDE'
                                : l.statusgravacao.toUpperCase()
                            }
                            type={l.statusgravacao}
                          />
                        </td>
                      </Tr>
                    ))}
                </tbody>
              </TableLinhaRoteiro>
            </Scroll>
          )}
        </>
        {linhasRoteiro.length <= 0 && !loading && (
          <p>Nenhuma linha encontrada</p>
        )}
        {loading && <p>Carregando...</p>}
      </Card>
    </Container>
  );
}
